import { useQuery } from '@tanstack/react-query'
import { freeTrialApi } from '@/api/freeTrials'

export function useLcTrialProgram(enabled = true) {
  return useQuery({
    queryKey: ['lcFreeTrialProgram'],
    queryFn: async () => {
      const response = await freeTrialApi.program()
      const program = response.data.data
      if (!program) {
        throw new Error('LC free-trial program data is missing')
      }
      return program
    },
    enabled,
  })
}
